(function(){
  function initReveal(){
    var els=document.querySelectorAll('.mt-reveal'); if(!els.length) return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('mt-visible')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('mt-visible');io.unobserve(x.target);}})},{threshold:.12});
    els.forEach(function(e){io.observe(e)});
  }
  function initGallery(){
    document.querySelectorAll('[data-mt-gal]').forEach(function(g){
      var main=g.querySelector('[data-mt-main]'), over=g.querySelector('.mt-gal__over');
      g.querySelectorAll('[data-mt-thumb]').forEach(function(b,i){
        b.addEventListener('click',function(){
          main.src=b.getAttribute('data-src'); main.srcset='';
          g.querySelectorAll('[data-mt-thumb]').forEach(function(x){x.classList.remove('is-on')}); b.classList.add('is-on');
          if(over) over.style.display=i===0?'':'none';
        });
      });
    });
  }
  function initPacks(){
    document.querySelectorAll('[data-mt-packs]').forEach(function(w){
      var form=w.closest('.mt-buy').querySelector('form[action*="/cart/add"]');
      var idInput=form?form.querySelector('input[name="id"]'):null;
      var btn=form?form.querySelector('[data-mt-add]'):null;
      var cards=w.querySelectorAll('.mt-pack');
      function sel(card){
        cards.forEach(function(c){c.classList.remove('is-on')}); card.classList.add('is-on');
        var r=card.querySelector('input'); r.checked=true;
        if(idInput) idInput.value=r.value;
        if(btn){ var av=card.getAttribute('data-available')==='true';
          btn.disabled=!av; btn.textContent=av?btn.getAttribute('data-label'):btn.getAttribute('data-soldout'); }
        document.querySelectorAll('[data-mt-sticky-price]').forEach(function(s){s.textContent=card.getAttribute('data-label')});
      }
      cards.forEach(function(c){c.addEventListener('click',function(){sel(c)})});
      var on=w.querySelector('.mt-pack.is-on')||cards[0]; if(on) sel(on);
    });
  }
  function initTabs(){
    document.querySelectorAll('[data-mt-tabs]').forEach(function(t){
      var bs=t.querySelectorAll('[data-tab]'), ps=t.querySelectorAll('[data-panel]');
      bs.forEach(function(b){b.addEventListener('click',function(){
        bs.forEach(function(x){x.classList.remove('is-on')}); b.classList.add('is-on');
        ps.forEach(function(p){p.classList.toggle('is-on',p.getAttribute('data-panel')===b.getAttribute('data-tab'))});
        var k=b.getAttribute('data-tab'),sec=t.closest('.mt-tlx');
        if(sec){sec.querySelectorAll('.mt-tlx__img img').forEach(function(im){im.classList.toggle('is-on',im.classList.contains(k))});}
      })});
    });
  }
  function initQuiz(){
    document.querySelectorAll('[data-mt-quiz]').forEach(function(q){
      var ans=q.querySelector('.mt-quiz__ans');
      q.querySelectorAll('.mt-quiz__opt').forEach(function(o){o.addEventListener('click',function(){
        q.querySelectorAll('.mt-quiz__opt').forEach(function(x){x.classList.remove('is-on')}); o.classList.add('is-on');
        if(ans) ans.classList.add('is-on');
      })});
    });
  }
  function initSticky(){
    var s=document.querySelector('.mt-sticky'); if(!s) return;
    var target=document.querySelector('[data-mt-packs]');
    window.addEventListener('scroll',function(){
      var show=window.scrollY>500;
      if(target){var r=target.getBoundingClientRect(); if(r.top<window.innerHeight&&r.bottom>0) show=false;}
      s.classList.toggle('is-on',show);
    },{passive:true});
  }
  document.addEventListener('DOMContentLoaded',function(){initReveal();initGallery();initPacks();initTabs();initQuiz();initSticky();});
})();
